// extracted by mini-css-extract-plugin
export default {"wrapper":"ResultQuiz_wrapper__b5-j-"};